import { axiosJwt } from '@/shared/auth/axiosJwt';
import { ChunkUploader } from '@/shared/utils/chunkUploader';

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CHECKINS_PORT}${process.env.VUE_APP_API_PATH}/checkins`;
const urlBase = `${api}/eventos`;
const formDataType = {
    headers: {
        'Content-Type': 'multipart/form-data',
    },
};

export default {
    obterTodos(filtros) {
        const timestamp = new Date().getTime();
        return axiosJwt.get(
            `${urlBase}?codigo=${filtros.codigo ?? ''}&codigoInterno=${filtros.codigoInterno ?? ''}&codigoExterno=${filtros.codigoExterno ?? ''}&nome=${
                filtros.nome ?? ''
            }&descricao=${filtros.descricao ?? ''}&dataInicio=${filtros.dataInicio ?? ''}&dataFim=${filtros.dataFim ?? ''}&_=${timestamp}`
        );
    },

    inserir(evento) {
        const formData = new FormData();

        formData.append('codigo', evento.codigo);
        formData.append('codigoInterno', evento.codigoInterno);
        formData.append('codigoExterno', evento.codigoExterno);
        formData.append('nome', evento.nome);
        formData.append('descricao', evento.descricao);
        formData.append('nivel', evento.nivel);

        if (evento.numeroInterno) {
            formData.append('numeroInterno', evento.numeroInterno);
        }

        if (evento.eventoPaiId) {
            formData.append('eventoPaiId', evento.eventoPaiId);
        }

        if (evento.contaEventoId) {
            formData.append('contaEventoId', evento.contaEventoId);
        }

        if (evento.sincronizarCheckinExterno) {
            formData.append('sincronizarCheckinExterno', evento.sincronizarCheckinExterno);
        }

        if (evento.geraAtendimento) {
            formData.append('geraAtendimento', evento.geraAtendimento);
        }

        if (evento.buscarCnpj) {
            formData.append('buscarCnpj', evento.buscarCnpj);
        }

        if (evento.pesquisarSomenteBaseEvento) {
            formData.append('pesquisarSomenteBaseEvento', evento.pesquisarSomenteBaseEvento);
        }

        if (evento.naoExibirFormularioNovoCredenciamento) {
            formData.append('naoExibirFormularioNovoCredenciamento', evento.naoExibirFormularioNovoCredenciamento);
        }

        if (evento.participantesInternos) {
            formData.append('participantesInternos', evento.participantesInternos);
        }

        formData.append('dataInicio', evento.dataInicio);
        formData.append('dataFim', evento.dataFim);

        if (evento.comercializacaoId) {
            formData.append('comercializacaoId', evento.comercializacaoId);
        }

        if (evento.comercializacaoDesc) {
            formData.append('comercializacaoDesc', evento.comercializacaoDesc);
        }
        return axiosJwt.post(`${urlBase}/inserir`, formData);
    },

    obterPorId(id) {
        return axiosJwt.get(`${urlBase}/${id}`);
    },

    obterEventosEvento(eventoId) {
        return axiosJwt.get(`${urlBase}/${eventoId}/eventos`);
    },

    obterCheckinsEvento(eventoId) {
        return axiosJwt.get(`${urlBase}/${eventoId}/checkins`);
    },
    obterListaAgenda(codEvento) {
        return axiosJwt.get(`${urlBase}/${codEvento}/agendas`);
    },

    gerarAtandimento(participantesCheckins, eventoid) {
        return axiosJwt.post(`${api}/participantes/evento/${eventoid}/geraratandimento`, participantesCheckins);
    },

    ativar(eventoId) {
        return axiosJwt.patch(`${urlBase}/${eventoId}/ativar`);
    },

    desativar(eventoId) {
        return axiosJwt.patch(`${urlBase}/${eventoId}/desativar`);
    },

    atualizar(data) {
        return axiosJwt.put(`${urlBase}/atualizar`, data);
    },

    obterAtendimentoDetalhePorEventoId(eventoId) {
        return axiosJwt.get(`${api}/eventos/${eventoId}/atendimentosdetalhes`);
    },

    obterOrientacaoEventoPaiPraFilho(eventoId) {
        return axiosJwt.get(`${api}/eventos/${eventoId}/atendimentosdetalhes/orientacaoTecnica`);
    },

    atualizarAtendimentoDetalhe(data, eventoId) {
        return axiosJwt.put(`${api}/eventos/${eventoId}/atendimentosdetalhes/atualizar`, data);
    },

    obterOpcoes(eventoId) {
        return axiosJwt.get(`${api}/eventos/${eventoId}/atendimentosdetalhes/opcoes`);
    },

    obterInstrumentoPicklistValues(eventoId) {
        return axiosJwt.get(`${api}/eventos/${eventoId}/atendimentosdetalhes/instrumentos/picklist`);
    },

    obterParceiroPorCpf(cpf, eventoId) {
        return axiosJwt.get(`${api}/eventos/${eventoId}/atendimentosdetalhes/responsavel/${cpf}`);
    },

    obterConfigsIntegracaoEvento(eventoId) {
        return axiosJwt.get(`${urlBase}/${eventoId}/configintegracao`);
    },

    atualizarConfigsIntegracaoEvento(eventoId, data) {
        return axiosJwt.put(`${urlBase}/${eventoId}/configintegracao/atualizar`, data);
    },

    atualizarMapaCorCordao(eventoId, mapaCorCordao) {
        return axiosJwt.put(`${urlBase}/${eventoId}/mapacorcordao/atualizar`, { eventoId, mapaCorCordao });
    },

    obterDashboard(eventoId) {
        return axiosJwt.get(`${api}/eventos/${eventoId}/dashboard`);
    },

    obterContasEventos() {
        return axiosJwt.get(`${api}/eventos/contas`);
    },

    gerarQrCode(eventoId) {
        return axiosJwt.get(`${api}/eventos/${eventoId}/qrcode`);
    },

    atualizarImagemCredenciamento(imagemCredenciamento) {
        const formData = new FormData();
        formData.append('eventoId', imagemCredenciamento.eventoId);
        formData.append('imagemCredenciamento', imagemCredenciamento.imagemCredenciamento);
        return axiosJwt.put(`${api}/eventos/${imagemCredenciamento.eventoId}/imagemcredenciamento`, formData, formDataType);
    },

    downloadImagemCredenciamento(eventoId) {
        return axiosJwt.get(`${api}/eventos/${eventoId}/imagemcredenciamento`, {
            responseType: 'blob',
        });
    },

    excluirImagemCredenciamento(eventoId) {
        return axiosJwt.delete(`${api}/eventos/${eventoId}/imagemcredenciamento`);
    },

    pesquisarEventoInterno(numeroInterno) {
        return axiosJwt.get(`${api}/eventos/pesquisareventointerno/${numeroInterno}`);
    },

    pesquisarTiposComercializacao(disponibilizacaoId) {
        return axiosJwt.get(`${api}/eventos/pesquisartiposcomercializacao/${disponibilizacaoId}`);
    },

    gerarQrCodeConfiguracao(listagemEventosQrCode) {
        return axiosJwt.post(`${api}/eventos/gerarlistaeventoqrcode`, listagemEventosQrCode, {
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'blob',
        });
    },

    /**
     * Retorna todas as landingPages no cache
     */
    obterTodasLandingPages() {
        return axiosJwt.get(`${urlBase}/landingPages`);
    },

    /**
     * Retorna todas as landingPages na camada de persistencia.
     */
    obterTodasLandingPagesPersistidas({ versaoAtual }) {
        return axiosJwt.get(`${urlBase}/landingPages/persistidas?versaoAtual=${versaoAtual ?? ''}`);
    },

    obterLandingPagePorEventoId(eventoId) {
        return axiosJwt.get(`${urlBase}/landingPages/por-evento/${eventoId}`);
    },

    obterLandingPagePorId(landingPageId) {
        return axiosJwt.get(`${urlBase}/landingPages/${landingPageId}`);
    },

    /**
     * Salva a landing page no cache.
     * @param {Object} pagina - Objeto contendo os dados da landing page a ser salvo.
     */
    salvarLandingPage(pagina) {
        return ChunkUploader.enviarEmChunks(pagina, (chunk) => axiosJwt.post(`${urlBase}/landingPages`, chunk));
    },

    desativarLandingPage(landingPageId) {
        return axiosJwt.patch(`${urlBase}/landingPages/${landingPageId}/desativar`);
    },

    excluirLandingPage(landingPageId) {
        return axiosJwt.delete(`${urlBase}/landingPages/${landingPageId}`);
    },

    /**
     * Persiste a landingPage, enviando o estado atual para o backend,
     * que irá atualizar o cache e salvar no banco de dados.
     * @param {Object} payload - O objeto completo da landing page.
     */
    persistirLandingPage(payload) {
        return ChunkUploader.enviarEmChunks(payload, (chunk) => axiosJwt.post(`${urlBase}/landingPages/persistir`, chunk));
    },

    /**
     * Inicia a edição de uma landing page. Esta função marca a landing page como em edição para evitar múltiplos usuários editando-a ao mesmo tempo
     * @param {string} landingPageId - Identificador único da landing page que será editada.
     */
    iniciarEdicaoLandingPage(landingPageId) {
        return axiosJwt.post(`${urlBase}/landingPages/${landingPageId}/iniciar-edicao`);
    },

    /**
     * Desmarca uma landing page como em edição para permitir edição por outro usuário.
     * @param {string} landingPageId - Identificador único da landing page que será finalizada a edição.
     */
    finalizarEdicaoLandingPage(landingPageId) {
        return axiosJwt.post(`${urlBase}/landingPages/${landingPageId}/finalizar-edicao`);
    },

    /**
     * Validar a url antes da publicação de uma landing page.
     * @param {string} url - A url customizada que será publicada.
     */

    verificarUrlLandingPage(url) {
        axiosJwt.get(`${urlBase}/landingPages/url/verificar/${encodeURIComponent(url)}`);
    },

    /**
     * Publica a landing page, alterando seu status para "Publicado".
     * @param {string} landingPageId - O ID da landing page a ser publicada.
     */

    publicarLandingPage(landingPageId) {
        return axiosJwt.post(`${urlBase}/landingPages/${landingPageId}/publicar`);
    },
};
